export default "__VITE_ASSET__DcVUrs$c__"